<template>
  <div :class="classes" @click="onToPath" v-if="(isErp === 1 && item.appCode === 'cloud_business') || isErp === 0">
    <span class="vi-sidebar-sub-item--text">{{item.reMenu}}</span>
    <span class="vi-sidebar-sub-item--tar">
      <i class="el-icon-loading" v-if="appLoading" style="color: #C8CCD5;top:2px;"></i>
      <i class="el-icon-caret-right" v-else></i>
    </span>
  </div>
</template>
<script>
  import MC from '@/module/MC'
  import { mapState } from 'vuex'
  import { handlerReEngSystem, ignoreMenuPath, xiaomiEnv } from './utils'

  const prefixCls = 'vi-sidebar-sub-item'
  export default {
    name: 'vi-sidebar-sub-item',
    data () {
      return {
      }
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      onToPath () {
        const { appCode, reUrl } = this.item

        // 跳转小蜜
        if (appCode === 'old_honey') {
          window.open(`${xiaomiEnv[global_env].url}/anonExecute/login?authorization=${MC.getAuth()}`)
          return
        }

        const system = handlerReEngSystem(appCode)
        const path = system !== 'app' ? `/${system}${reUrl}` : `${reUrl}`
        this.$router.push({ path })
      }
    },
    watch: {},
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['currentParentPath', 'appLoading', 'isErp']),
      classes () {
        return [
          `${prefixCls}`,
          {
            [`${prefixCls}--active`]: ignoreMenuPath().includes(this.item.reUrl)
          }
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  $-prefix-cls: "vi-sidebar-sub-item";
  .#{$-prefix-cls} {
    height: 42px;
    line-height: 40px;
    position: relative;
    z-index: 1;
    margin: 4px 6px;
    cursor: pointer;
    border-radius:4px;
    transition: all 0.5s ease-out;
    &--text {
      font-size: 13px;
      color: rgb(74, 74, 74);
      padding-left: 26px;
      transition: all 0.3s ease-out;
      display: inline-block;
    }
    &:hover {
      background-color: #EDF2FD;
      .#{$-prefix-cls}--text {
        transition: all 0.3s ease-out;
        transform: translate(-8px,0px);
      }
    }
    &--tar {
      position: absolute;
      right: 4px;
      top: 1px;
      opacity: 0;
      >i {
        font-size: 14px;
        color: #4f88ff;
      }
    }

    &--active {
      background-color: #edf2fd;
      .#{$-prefix-cls}--text {
        color: #4f88ff;
        transform: translate(-8px,0px);
      }
      .#{$-prefix-cls}--tar {
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/sidebarSubItem.vue